import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Context } from '../context';

export function PlayerVideoHeader(props) {
  const context = useContext(Context);
  return (
    <>
      <div className="l_content_player_header shown">
        <div className="ui_tabs ui_tabs--player">
          <div className="ui_tabs__ul">
            <div className="ui_tabs__li">
              {/* <div className="ui_tabs__menu_item ui_tabs__menu_item--header">
                <div>Designing a complex body from scratch...</div>
                <div className="l_player_subline">
                  <div className="x_user0">
                    <div className="x_user_ava">
                      <img src="https://assets.website-files.com/61785133118e574036320746/617c93325ecb8e8faf14698d_joe.png" loading="lazy" alt className="p_user_ava_img p_user_ava_img--sm" />
                    </div>
                    <h5 className="x_user_name">
                      <span>
                        <strong>Joseph Douglas</strong>
                      </span>
                    </h5>
                  </div>
                  <div>Jul 13, 2022</div>
                </div>
              </div> */}
            </div>
            <div className="ui_tabs__li ui_tabs__li--right">
              <div className="ui_tabs__menu_item">

                <div className="m_ico">
                  <div>cast</div>
                </div>

                <div>Cast</div>
              </div>

              <div className="ui_tabs__menu_item">

                <div className="m_ico" style={{ fontSize: 26 }}>
                  <div>fit_screen</div>
                </div>

                <div>Theater</div>
              </div>


              <div className="ui_tabs__menu_item">

                <div className="m_ico" style={{ fontSize: 26 }}>
                  <div>fullscreen</div>
                </div>

                <div>Fullscreen</div>
              </div>


              <div className="ui_tabs__menu_item">
                <div>
                  <div className="m_ico">
                    <div>close</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}